/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CheckoutSession = core.serialization.object({
    id: core.serialization.string().optional(),
    object: core.serialization.string().optional(),
});
